import { format, parseISO } from "date-fns"
import { MRT_Cell, MRT_ColumnDef } from "material-react-table"
import { RunDto } from "@custom-types/modelRun"
import { getRunName } from "utils/run"

export const getNumberWithOrdinal = function (n: number) {
  const s = ["th", "st", "nd", "rd"]
  const v = n % 100
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export enum CompareType {
  None,
  Smirnov,
  Tornado,
  Graph_Diff,
}

export const getAnalyticsTableColumnsForMaterialTable = (): MRT_ColumnDef<RunDto>[] => [
  {
    accessorKey: "key",
    header: "ID",
  },
  {
    accessorFn: (run) => getRunName(run),
    header: "Name",
    size: 130,
  },
  // {
  //   accessorKey: "owner_group_key",
  //   header: "Owner Group Key",
  // },
  // {
  //   accessorKey: "model_key",
  //   header: "Model Key",
  // },
  {
    accessorKey: "base_graph_key",
    header: "Graph",
    filterFn: "equals",
    size: 125,
    Cell: ({ cell }: { cell: MRT_Cell<RunDto> }) => {
      return (cell.getValue() as string).split("#").slice(-1)
    },
  },
  {
    accessorKey: "simulation_frequency",
    header: "Simulation Frequency",
    filterFn: "equals",
    size: 125,
  },
  {
    accessorKey: "yearly_rolling_start_month",
    header: "Yearly Start Month",
    filterFn: "equals",
    size: 125,
  },
  {
    accessorKey: "version",
    header: "Version",
    size: 50,
  },
  {
    accessorKey: "creator_email",
    header: "Creator",
    size: 100,
  },
  {
    accessorKey: "creation_date",
    header: "Date",
    size: 80,
    Cell: ({ cell }: { cell: MRT_Cell<RunDto> }) =>
      parseISO(cell.getValue() as string)
        ? format(parseISO(cell.getValue() as string), "RRRR-LL-dd HH:mm")
        : "",
  },
  // {
  //   accessorKey: "status",
  //   header: "Status",
  //   size: 150,
  // },
  // {
  //   accessorKey: "num_samples",
  //   header: "Samples",
  //   type: "number",
  //   size: 20,
  // },
  // {
  //   accessorKey: "seed",
  //   header: "Seed",
  //   size: 20,
  // },
]
